"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var styled_components_1 = __importDefault(require("styled-components"));

var Icon = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 15px;\n  margin-right: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 18px;\n"], ["\n  padding: 15px;\n  margin-right: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 18px;\n"])));
var Text = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 16px;\n"], ["\n  font-size: 16px;\n"])));
var Close = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  margin-left: auto;\n  svg {\n    fill: #333333;\n  }\n"], ["\n  cursor: pointer;\n  margin-left: auto;\n  svg {\n    fill: #333333;\n  }\n"])));
var Container = styled_components_1.default("div")(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-family: \"Nunito Sans\", sans-serif;\n  width: ", ";\n  display: flex;\n  align-items: center;\n  border-radius: 3px;\n  overflow: hidden;\n  background-color: white;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n  padding-right: 15px;\n  ", " {\n    background-color: ", ";\n  }\n  ", " {\n    color: ", ";\n  }\n"], ["\n  font-family: \"Nunito Sans\", sans-serif;\n  width: ", ";\n  display: flex;\n  align-items: center;\n  border-radius: 3px;\n  overflow: hidden;\n  background-color: white;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n  padding-right: 15px;\n  ", " {\n    background-color: ", ";\n  }\n  ", " {\n    color: ", ";\n  }\n"])), function (props) {
  return props.width;
}, Icon, function (props) {
  if (props.theme === "primary") {
    return "#2D4EF5";
  } else if (props.theme === "success") {
    return "#4CE2A7";
  } else if (props.theme === "error") {
    return "#E24C4C";
  } else if (props.theme === "alert") {
    return "#F1A153";
  } else if (props.theme === "dark") {
    return "#022047";
  }
}, Text, function (props) {
  if (props.theme === "primary") {
    return "#2D4EF5";
  } else if (props.theme === "success") {
    return "#4CE2A7";
  } else if (props.theme === "error") {
    return "#E24C4C";
  } else if (props.theme === "alert") {
    return "#F1A153";
  } else if (props.theme === "dark") {
    return "#022047";
  }
});

exports.Notification = function (_a) {
  var _b = _a.theme,
      theme = _b === void 0 ? "primary" : _b,
      icon = _a.icon,
      text = _a.text,
      onClose = _a.onClose,
      _c = _a.width,
      width = _c === void 0 ? "550px" : _c,
      className = _a.className;
  return react_1.default.createElement(Container, {
    className: className,
    theme: theme,
    width: width
  }, react_1.default.createElement(Icon, null, icon), react_1.default.createElement(Text, null, text), react_1.default.createElement(Close, {
    onClick: onClose
  }, react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 24 24"
  }, react_1.default.createElement("path", {
    d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"
  }))));
};

exports.Notification.propTypes = {
  theme: prop_types_1.default.oneOf(["primary", "success", "error", "alert", "dark"]),
  text: prop_types_1.default.string.isRequired,
  icon: prop_types_1.default.any,
  onClose: prop_types_1.default.func,
  width: prop_types_1.default.string,
  className: prop_types_1.default.string
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;